import topTitle from '@/components/title';
import { policyListTag0, policyListTag11, policyListTag21 } from './../utils.js';
import { mapState } from 'vuex';
export default {
  components: {
    topTitle
  },
  computed: {
    ...mapState({
      accountInfo: state => state.user.accountInfo
    })
  },
  props: {
    policyInfo: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      policyInfoList: []
    };
  },
  mounted() {
    this.policyInfoList = this.accountInfo.tag == 0 ? policyListTag0 : this.accountInfo.tag == 1 ? policyListTag11 : policyListTag21;
  }
};